const PermissionMenu = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "menu": "Menu",
    "sub_menu": "Sub Menu",
    "action_name": "Action Name",
    "api": "API",
    "permission": "Permission",
    "route": "Route",
    "show_in_menu": "Show In Menu",
    "search": "Search",

    // PAGE HEADER
    "permisiion_menu": "Permission Menu",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_menu": "Select Menu",
    "error_sub_menu": "Select Sub Menu",
    "error_action_name": "Enter Action Name",
    "error_route_required": "Enter Route",
    "error_route_matches": "Enter Correct Path",
    "error_show_in_menu": "Select Show in Menu",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_main_menu": "MAIN MENU",
    "table_sub_menu": "SUB MENU",

}

export default PermissionMenu;